// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__bNsrO","close-button":"Modal_close-button__q8T4L","text-container":"Modal_text-container__-HlCJ","text":"Modal_text__5uXe9"};